import React, { CSSProperties, ReactNode } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

type ExternalContentProps = {
  modifier?: Modifier<'no-padding'>;
  style?: CSSProperties;
  children: ReactNode;
};
export function IFrameContainer({ modifier, style, children }: ExternalContentProps) {
  return (
    <div className={bem('iframe__container', modifier)} style={style}>
      {children}
    </div>
  );
}
